import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { CONTACT } from "@/data/site";

export const FloatingWhatsApp = () => {
  return (
    <motion.a
      href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Ciao! Vorrei informazioni sui vostri corsi.")}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Scrivici su WhatsApp"
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.08 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      className="fixed bottom-24 md:bottom-5 left-4 md:left-5 z-[67] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)]"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
      <FaWhatsapp size={26} className="relative" />
    </motion.a>
  );
};
